import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request's generic "something went wrong" toast (in
 * error.interceptor.ts) as suppressed. For a periodic poll, one transient
 * failure isn't worth interrupting the user — polling either succeeds on
 * its next tick or the caller has its own consecutive-failure handling to
 * surface something more useful than a toast every couple of seconds.
 * A 401 on a silenced request still logs the user out as normal; only the
 * generic-error branch checks this.
 */
export const SILENT_ERROR = new HttpContextToken<boolean>(() => false);

export function silentError(): HttpContext {
  return new HttpContext().set(SILENT_ERROR, true);
}
